import React, { Component, PropTypes } from 'react'
import { translate } from 'react-i18next'
import R from 'ramda'
import { Fonts, Colors, Metrics } from '../../Themes'
import styled from 'styled-components'
import AuthActions from '../../actions/AuthActions'
import jwtDecode from 'jwt-decode'
import {
  isErrorOfInvalidAttribute,
  addOrRemoveObjectFromList
} from '../../Utils'
import { validateInput } from '../../Utils/Validations'
import { registerUser } from '../../sources/AuthSources'
import { errorMessages } from '../../Utils/ErrorMessages'
import {
  fetchPublicCategories,
  searchPublicCity,
  searchPublicContinent,
  searchPublicCountry
} from '../../sources/SearchSource'
import { userDefault } from '../../Utils/Defaults'

const Container = styled.div`
  text-align: center;

  h1 {
    margin-bottom: ${Metrics.margins.base};
    margin-top: ${Metrics.margins.base};
    ${Fonts.style.OrangeSubtitle};
  }

  .error-view {
    button {
      margin-top: ${Metrics.margins.base};
    }
  }

  ul {
    padding: 0;
    list-style: none;
    text-align: left;

    li {
      display: inline-block;
      width: 33%;
    }
  }

  .other {
    .inputTitle {
      display: inline-block;
      color: ${Colors.black};
    }
    .formContainer {
      margin-left: ${Metrics.margins.base};
      display: inline-block;
    }
  }

  p {
    ${Fonts.style.Text};
    &.justify {
      text-align: justify;
    }
  }

  @media screen and (max-width: 768px) {
    ul {
      li {
        width: 50%;
      }
    }
  }
`

class Signup extends Component {
  constructor (props) {
    super(props)
    this.state = {
      profile: R.clone(userDefault),
      searches: {
        categories: [],
        cities: [],
        citySearch: '',
        countries: [],
        countrySearch: '',
        continents: [],
        continentSearch: ''
      },
      confirmPassword: '',
      errors: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        address: '',
        city: '',
        country: '',
        general: ''
      },
      fetching: false,
      errorMessage: ''
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleRegister = this.handleRegister.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.handleSelectAll = this.handleSelectAll.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleRange = this.handleRange.bind(this)
    this.handleConfirm = this.handleConfirm.bind(this)
    this.validateForm = this.validateForm.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.next = this.next.bind(this)
  }

  componentWillMount () {
    const {
      firstName,
      lastName,
      email,
      linkedin,
      company,
      id,
      state,
      jobTitle,
      error
    } = this.props.location.query
    const { router } = this.props
    if (error) {
      let errorMessage = errorMessages.linkedinAuthentication
      this.setState({ errorMessage }, () =>
        router.push('/landing/signup/error')
      )
      return
    }
    if (email) {
      const profile = this.state.profile
      profile.firstName = firstName
      profile.lastName = lastName
      profile.email = email
      profile.company = company
      profile.jobTitle = jobTitle
      profile.linkedinUrl = linkedin
      profile.linkedinId = id
      this.setState({ profile })
    }

    if (state) {
      const profile = jwtDecode(window.localStorage.getItem('hvbToken')).user
      this.setState({ profile })
    }

    fetchPublicCategories()
      .then(response => {
        let { searches } = this.state
        searches.categories = response.data
        this.setState({ searches })
      })
      .catch(error => console.log(error))
  }

  handleSelect (key, el) {
    const { profile } = this.state
    let selectedOptions = this.state.profile[key]
    profile[key] = addOrRemoveObjectFromList(selectedOptions, el)

    if (
      key === 'preferredCities' ||
      key === 'preferredCountries' ||
      key === 'preferredRegions'
    ) {
      let searches = {
        categories: [],
        cities: [],
        citySearch: '',
        countries: [],
        countrySearch: '',
        continents: [],
        continentSearch: ''
      }
      this.setState({ profile, searches })
    } else {
      this.setState({ profile })
    }
  }

  handleSelectAll (key, list) {
    this.setState(
      { profile: { ...this.state.profile, [key]: userDefault[key] } },
      () => list.forEach(el => this.handleSelect(key, el))
    )
  }

  handleChange (key, event) {
    const { profile } = this.state
    profile[key] = event.target.value
    this.setState({ profile })
  }

  handleConfirm (event) {
    this.setState({ confirmPassword: event.target.value })
  }

  handleRange (minKey, maxKey, value) {
    const profile = this.state.profile
    profile[minKey] = value.min
    profile[maxKey] = value.max
    this.setState({ profile })
  }

  handleSearch (event, key) {
    const { searches } = this.state
    const value = event.target.value
    switch (key) {
      case 'preferredCities':
        searchPublicCity({
          where: { city: { startsWith: value } }
        }).then(response => {
          searches.citySearch = value
          searches.cities = response.data
          this.setState({ searches })
        })
        break
      case 'preferredCountries':
        searchPublicCountry({
          where: { name: { startsWith: value } }
        }).then(response => {
          searches.countrySearch = value
          searches.countries = response.data
          this.setState({ searches })
        })
        break
      case 'preferredRegions':
        searchPublicContinent({
          where: { name: { startsWith: value } }
        }).then(response => {
          searches.continentSearch = value
          searches.continents = response.data
          this.setState({ searches })
        })
        break
      default:
        break
    }
  }

  handleRegister () {
    let profile = R.clone(this.state.profile)
    const { router } = this.props
    profile.preferredCities =
      profile.preferredCities.length > 0 &&
      profile.preferredCities.map(el => {
        return el.id
      })

    profile.preferredCountries =
      profile.preferredCountries.length > 0 &&
      profile.preferredCountries.map(el => {
        return el.id
      })

    profile.preferredRegions =
      profile.preferredRegions.length > 0 &&
      profile.preferredRegions.map(el => {
        return el.id
      })

    profile.preferredCategories =
      profile.preferredCategories.length > 0 &&
      profile.preferredCategories.map(el => {
        return el.id
      })

    this.setState({ fetching: true }, () => {
      return registerUser(profile)
        .then(response => {
          this.setState(
            { fetching: false, profile: response.data.token.user },
            () => {
              router.push('/landing/signup/ncnda')
              AuthActions.storeToken(response.data.token)
            }
          )
        })
        .catch(error => {
          let errorMessage = errorMessages.general
          if (
            error.response &&
            isErrorOfInvalidAttribute(error.response, 'email', 'unique')
          ) {
            errorMessage = errorMessages.emailAlreadyExists
          }

          this.setState({ fetching: false, errorMessage }, () =>
            router.push('/landing/signup/error')
          )
        })
    })
  }

  validateForm () {
    const requiredFields = document.querySelectorAll('[required]')
    let errors = this.state.errors
    let valid = true
    for (var k = 0; k < requiredFields.length; k++) {
      errors = validateInput(
        requiredFields[k].name,
        this.state.profile[requiredFields[k].name],
        errors
      )
      valid = valid && errors[requiredFields[k].name] === ''
    }
    errors.general = !valid ? 'Please fill in all the required fields' : ''
    this.setState({ errors })
    return valid
  }

  next (route) {
    if (this.validateForm()) {
      this.props.router.push(route)
    }
  }

  handleBlur (name, value, errors) {
    let newErrors = validateInput(name, value, errors)
    this.setState({ errors: newErrors })
  }

  render () {
    const { children } = this.props
    return (
      <Container>
        {children &&
          React.cloneElement(children, {
            profile: this.state.profile,
            searches: this.state.searches,
            confirmPassword: this.state.confirmPassword,
            validForm: this.state.validForm,
            errors: this.state.errors,
            handleSelect: this.handleSelect,
            handleSelectAll: this.handleSelectAll,
            handleChange: this.handleChange,
            handleConfirm: this.handleConfirm,
            handleSearch: this.handleSearch,
            handleRegister: this.handleRegister,
            handleBlur: this.handleBlur,
            handleRange: this.handleRange,
            next: this.next,
            fetching: this.state.fetching,
            errorMessage: this.state.errorMessage
          })}
      </Container>
    )
  }
}

Signup.propTypes = {
  errorMessage: PropTypes.string,
  location: PropTypes.object,
  router: PropTypes.object,
  children: PropTypes.node
}

export default translate([ 'common', 'landing', 'forms' ], { wait: true })(
  Signup
)



// WEBPACK FOOTER //
// ./src/pages/Landing/Signup.js